import { Link } from "react-router-dom";

import { Card } from "@/components/card";
import { Badge } from "@/components/ui/badge";
import { PublicEvent } from "@classview/shared-types";

import { EventAttendingBadge } from "./event-attending-badge";
import { EventDetails } from "./event-details";
import { EventOrganiser } from "./event-organiser";
import { EventThumbnail } from "./event-thumbnail";

type MyEventItemProps = {
  event: PublicEvent;
};

export function MyEventItem({ event }: MyEventItemProps) {
  return (
    <Card className="flex" as="article" isHorizontal>
      <Link className="group relative block" to={`/events/${event.id}`}>
        <EventThumbnail
          bannerImageUrl={event.bannerS3Path}
          className="h-[calc(100%-8px)] min-w-[150px]"
        />
      </Link>
      <Card.Content className="flex-1 pt-3">
        <Link className="relative flex flex-col" to={`/events/${event.id}`}>
          <div className="flex items-center justify-between">
            <Badge variant="primary">
              <span className="capitalize">{event.category.toLowerCase()}</span>
            </Badge>
            <EventAttendingBadge />
          </div>
          <div className="text-md mt-2 font-semibold text-foreground">
            {event.session.name}
          </div>
          <div className="mb-5 mt-2 flex flex-row items-center justify-between">
            <EventDetails
              type={event.type}
              startAt={event.session.start}
              endAt={event.session.end}
            />
          </div>
          <div className="flex items-start space-x-2">
            <div className="flex flex-wrap gap-6">
              <EventOrganiser
                firstName={event.session.organiser.firstName}
                lastName={event.session.organiser.lastName}
                avatarURL={event.session.organiser.avatarURL}
              />
            </div>
          </div>
        </Link>
      </Card.Content>
    </Card>
  );
}
